var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"single-tag",class:{ the_tag: _vm.subjectValue === _vm.theSubject },on:{"click":function($event){return _vm.searchSubject(_vm.subjectValue)}}},[_vm._v(" "+_vm._s(_vm.subjectValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }